var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";
export function AtpveInfo(_a) {
    var serviceName = _a.serviceName, data = _a.data, handleShowBoleto = _a.handleShowBoleto;
    return (_jsxs("section", __assign({ className: "w-full max-w-[856px] py-4 sm:py-0.5 bg-light-blue-100 flex justify-start gap-4 sm:justify-between px-6 rounded-lg" }, { children: [_jsx("div", __assign({ className: "flex gap-5 items-center h-[100px]" }, { children: _jsxs("div", __assign({ className: cn("hidden sm:block") }, { children: [_jsx("p", __assign({ className: "font-medium" }, { children: "N\u00FAmero ATPV-e" })), _jsx("span", __assign({ className: "font-normal" }, { children: data === null || data === void 0 ? void 0 : data.numeroATPVe }))] })) })), _jsx("div", __assign({ className: "h-[150px] flex flex-col items-start justify-center sm:h-auto sm:items-center" }, { children: _jsx(Button, __assign({ className: " md:px-14 bg-etipi-blue", onClick: function () { return handleShowBoleto(true); } }, { children: "Visualizar" })) }))] })));
}
